module.exports = __webpack_public_path__ + "static/media/sel_15_264.8ec0a1b3.mp4";